import React from 'react';
import { RingMetricProps } from './types';
import { METRIC_POSITIONS } from './constants';

export function RingMetric({ config, onClick }: RingMetricProps) {
  const { label, value, unit, icon, colors, position } = config;
  const Icon = icon.component;

  return (
    <button
      onClick={onClick}
      className={`absolute flex flex-col items-center gap-1 p-2 rounded-lg 
        ${METRIC_POSITIONS[position]}
        active:bg-muted/50 active:opacity-80
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary`}
    >
      <div className={`relative ${colors.base}`}>
        <Icon {...icon.props} />
      </div>
      <div className="text-sm font-medium">{label}</div>
      <div className={`text-xl font-bold ${colors.base}`}>
        {typeof value === 'number' ? value.toFixed(1) : value}
        {unit && <span className="text-sm ml-0.5">{unit}</span>}
      </div>
    </button>
  );
}